<template>
    <v-form ref="form_referencia_personales">
        <v-container fluid grid-list-md v-show="_.size(listGeneral.cabeceraReferenciaPersonal) > 0">
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-dialog v-model="abrirModal" :max-width="tamModal" :fullscreen="$root.isTouch"
                        :scrollable="$root.isTouch == false" persistent>
                        <template v-slot:activator="{ on }">
                            <div class="text-right">
                                <v-btn rounded dark color="primary" v-on="on">Nuevo</v-btn>
                            </div>
                        </template>
                        <v-card>
                            <v-card-title class="bg-title-card">
                                <span class="white--text headline" v-html="titulo"></span>
                            </v-card-title>
                            <v-container fluid grid-list-md>
                                <v-form ref="form_modal_referencia_personal">
                                    <v-row dense>
                                        <v-col cols="12" sm="6">
                                            <v-text-field label="Nombres *" color="textbox" v-model="objModal.nombres"
                                                :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objModal.nombres,200))"
                                                outlined dense></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field label="Apellidos *" color="textbox"
                                                v-model="objModal.apellidos"
                                                :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objModal.apellidos,200))"
                                                outlined dense></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="4">
                                            <v-text-field label="Parentesco *" color="textbox"
                                                v-model="objModal.parentesco"
                                                :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objModal.parentesco,200))"
                                                outlined dense></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="8">
                                            <v-text-field label="Dirección *" color="textbox"
                                                v-model="objModal.direccion" :rules="requeridoRegla" outlined dense>
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="6">
                                            <v-autocomplete label="Provincia *" color="textbox"
                                                v-model="objModal.idProvincia" :items="listGeneral.listaProvincia"
                                                autocomplete :rules="requeridoRegla"
                                                @change="onListarCantones('listaCantonRefPer')" outlined dense>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-autocomplete label="Cantón *" color="textbox"
                                                :disabled="_.isUndefined(objModal.idProvincia)"
                                                v-model="objModal.idCanton" :items="listGeneral.listaCantonRefPer"
                                                item-value="idCanton" item-text="canton" autocomplete
                                                :rules="requeridoRegla" outlined dense> </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" class="text-right mt-3 mb-3">
                                            <v-btn outlined dense rounded class="mr-1" color="danger" @click="reset">
                                                Cancelar</v-btn>
                                            <v-btn rounded dark color="primary" @click="validarModal">Guardar</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="6" />
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" v-model="objForm.busqueda" dense
                        prepend-inner-icon="search"></v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-data-table :search="objForm.busqueda" :headers="listGeneral.cabeceraReferenciaPersonal"
                        :items="listGeneral.listaReferenciaPersonal" class="elevation-3">

                        <template v-slot:item.nombres="{ item }">
                            {{ `${item.nombres} ${item.apellidos}` }}
                        </template>

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="onEditar(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-text="objForm.busqueda"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12" class="text-right mt-3 mb-3">
                    <v-btn outlined rounded color="danger" class="mr-1" @click="previous('objRefPer',objForm)">Anterior</v-btn>
                    <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        name: 'StepperReferenciaPersonalComponent',
        inject:['previous','next'],
        props:{
            cargar:{ type:Boolean, default: false },
            objForm:{ type:Object, default: {} },
            listGeneral:{ type:Object, default: {} },
            parametro:{ type:Object, default: {} }
        },
        data: () => ({
            titulo: 'Nuevo Registro de Referencia Personal',
            objModal:{},
            abrirModal: false            
        }),
        watch:{
            cargar(val){
                if(val && _.size(this.listGeneral.listaReferenciaPersonal)==0){
                    this.listGeneral.cabeceraReferenciaPersonal = [];
                    var error = 'E';
                    var objeto = _.merge({},this.objForm,{ opcion: 'CAB_REFERENCIA_PERSONAL' })
                    
                    axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`,objeto)
                         .then((r) => {
                            if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }                                
                                this.$set(this.listGeneral,'cabeceraReferenciaPersonal',r.data.data);
                                var objeto = _.merge({},_.omit(this.objForm,'idEstado'),{ opcion: 'LISTAR_REFERENCIA_PERSONALES'});

                                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`,objeto);
                         })
                         .then((r) => {
                            if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }                                
                                this.$set(this.listGeneral,'listaReferenciaPersonal',_.map(r.data.data, (v) => { v.id = _.uniqueId(); return v; }) );
                         })
                         .catch((e)=>{
                            mensajesAlerta(e, error);
                         });
                }
            }
        },
        methods:{
            validar(){
                if(this.$refs.form_referencia_personales.validate())
                    this.next('objRefPer',this.objForm);
            },
            validarModal(){
                if(this.$refs.form_modal_referencia_personal.validate()){
                    if(_.isNull(this.objModal.id) || _.isUndefined(this.objModal.id))
                        this.listGeneral.listaReferenciaPersonal.push(_.merge({},this.objModal,{'id': _.uniqueId(), 'idEstado': this.parametro.idEstadoDefault }));
                    else{
                        var pos = _.findIndex(this.listGeneral.listaReferenciaPersonal, (o) => { return parseInt(o.id) == parseInt(this.objModal.id); });
                        this.listGeneral.listaReferenciaPersonal[pos] = _.merge(this.listGeneral.listaReferenciaPersonal[pos],this.objModal);
                    }
                    this.reset();
                }
            },
            onListarCantones(){
                var objeto = {
                                opcion         : 'L',
                                idProvincia    : this.objForm.idProvincia,
                                idEstado       : this.parametro.idEstadoDefault
                            };
                var error = 'E';

                return axios.post(`${BASE_URI}administrador/canton/listar`,objeto)
                            .then((r) => {
                                if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                                    this.$set(this.listGeneral,'listaCantonRefPer',r.data.data);

                                    return r;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e, error);
                                return e;
                            });
            },
            onEditar(objeto){
                this.$set(this,'objModal',objeto);
                this.titulo = 'Editar Registro de Referencia Personal';

                this.onListarCantones()
                    .then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) > 0)
                            this.abrirModal = !this.abrirModal;
                    });
            },
            reset(){
                this.abrirModal = !this.abrirModal;
                this.$set(this,'objModal',{});
                this.$set(this.listGeneral,'listaCantonRefPer',[]);
                this.titulo = 'Nuevo Registro de Referencia Personal';
                if(!_.isUndefined(this.$refs.form_modal_referencia_personal))
                    this.$refs.form_modal_referencia_personal.resetValidation();
            }
        }
    }
</script>